import styled, { keyframes } from "styled-components";
import { Icon as IconComponent } from "../../Icon/Icon";
const pulsate = keyframes `
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.4);
  }
`;
export const Icon = styled(IconComponent) `
  &.pulsating {
    animation: ${pulsate} 1s ease-in-out infinite alternate;
  }

  width: auto;

  && > * {
    height: 100%;
    width: auto;

    > svg {
      max-width: initial;
      height: 100%;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01pdHR3YWxkSWNvbi9zdHlsZWQvSWNvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE1BQU0sRUFBRSxFQUFFLFNBQVMsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3RELE9BQU8sRUFBRSxJQUFJLElBQUksYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFeEQsTUFBTSxPQUFPLEdBQUcsU0FBUyxDQUFBOzs7Ozs7O0NBT3hCLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFBOztpQkFFeEIsT0FBTzs7Ozs7Ozs7Ozs7Ozs7Q0FjdkIsQ0FBQyJ9